import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getSortingIcon = (sorted: 'asc' | 'desc' | false) => {
  if (sorted === 'asc') return <FontAwesomeIcon icon={faArrowDown} />;
  if (sorted === 'desc') return <FontAwesomeIcon icon={faArrowUp} />;
  return null;
};
